"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormItem = _interopRequireDefault(require("./FormItem"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _radio = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/radio.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _radio.default);

var FormRadioItem = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _classnames;

  var checked = _ref.checked,
      children = _ref.children,
      compact = _ref.compact,
      cssNamespace = _ref.cssNamespace,
      data = _ref.data,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      id = _ref.id,
      inline = _ref.inline,
      inputProps = _ref.inputProps,
      labelProps = _ref.labelProps,
      name = _ref.name,
      state = _ref.state,
      value = _ref.value,
      props = (0, _objectWithoutProperties2.default)(_ref, ["checked", "children", "compact", "cssNamespace", "data", "defaultChecked", "disabled", "id", "inline", "inputProps", "labelProps", "name", "state", "value"]);
  var inputClassName = classnames("".concat(cssNamespace, "-radio"), (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-radio--compact"), compact), (0, _defineProperty2.default)(_classnames, "is-".concat(state), state), _classnames));
  var generatedRadioId = (0, _useUniqueId.default)();
  var radioId = id || generatedRadioId;
  return /*#__PURE__*/_react.default.createElement(_FormItem.default, (0, _extends2.default)({}, props, {
    isInline: inline,
    key: id
  }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, inputProps, {
    checked: checked,
    className: inputClassName,
    disabled: disabled,
    id: radioId,
    name: name,
    ref: ref,
    type: "radio",
    value: value
  })), /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({}, labelProps, {
    className: classnames("".concat(cssNamespace, "-radio__label")),
    disabled: disabled,
    htmlFor: radioId
  }), children));
});

FormRadioItem.displayName = 'FormRadioItem';
process.env.NODE_ENV !== "production" ? FormRadioItem.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node.isRequired,

  /** Set to **true** when radio input is checked and a controlled component */
  checked: _propTypes.default.bool,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Payload to be used for onChange callback when this `FormRadioItem` is selected in a `FormRadioGroup`.*/
  data: _propTypes.default.any,

  /** Set to **true** when the radio input is checked and an uncontrolled component */
  defaultChecked: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Internal use only */
  inline: _propTypes.default.bool,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Additional props to be spread to the `<label>` element */
  labelProps: _propTypes.default.object,

  /** Sets the `name` for the radio input */
  name: _propTypes.default.string,

  /** State of validation: 'error', 'warning', 'information', 'success' */
  state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

  /** Sets the `value` for the radio input */
  value: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(FormRadioItem);

exports.default = _default;